export class AllowedFieldsConstants {
  /**
   * f_type: Array contains field types which should be ignored
   * name: Array contains field names which should be ignored
   * f_searchable: String which should match (String values should match)
   * f_transientField: Boolean which should not match (boolean is designed to not match considering null, undefined cases)
   * sysGen: Boolean which should not match
   */
  public static defaultFilter = {
    f_type: ['image carousel', 'file attachments', 'color', 'url'],
    searchable: true,
    f_transientField: true,
    name: ['sid', 'pid', 'sync time']
  };
  public static paramMappingSource = {
    f_type: ['image carousel', 'file attachments', 'color', 'url'],
    searchable: true,
    f_transientField: true,
    name: ['sync time']
  };
  public static paramMappingTarget = {
    f_type: ['image carousel', 'file attachments', 'color', 'url', 'auto-number']
  };
  public static sourceFields = {
    f_type: ['image carousel', 'file attachments'],
    name: ['sync time']
  };
  public static targetFields = {
    f_type: ['image carousel', 'file attachments', 'auto-number']
  };
}
